// Pure helpers for the Projects view — progress, due-state and assignee
// filtering. Extracted so the date/percent logic is unit-testable without
// rendering. (Projects is still the demo preview; these move over cleanly when
// the real data model lands in Phase B.)

// { done, total, pct, doneStatus } for a project. The last status in the list
// is treated as "done".
export function projectProgress(project) {
  const doneStatus = project.statuses[project.statuses.length - 1];
  const total = project.tasks.length;
  const done = project.tasks.filter(t => t.status === doneStatus).length;
  const pct = total ? Math.round((done / total) * 100) : 0;
  return { done, total, pct, doneStatus };
}

// 'overdue' | 'soon' | null for a task. "soon" = due within `soonDays` and not
// yet done; done tasks and tasks with no due date return null.
export function dueState(task, doneStatus, now = new Date(), soonDays = 3) {
  if (!task.due || task.status === doneStatus) return null;
  const todayIso = now.toISOString().slice(0, 10);
  const today = new Date(todayIso + 'T00:00:00').getTime();
  const due = new Date(task.due + 'T00:00:00').getTime();
  if (isNaN(due)) return null;
  if (due < today) return 'overdue';
  if (due <= today + soonDays * 86400000) return 'soon';
  return null;
}

// Filter a task list to one assignee (null = show all).
export function visibleTasks(tasks, assigneeId) {
  if (!assigneeId) return tasks;
  return tasks.filter(t => t.assigneeId === assigneeId);
}
